export default __webpack_public_path__ + "static/Harvester1-139a8a14b47f063705548e178b7bd90c.jpg";